import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {
  constructor(private readonly http: HttpClient) {}

  forgotPassword(payload:any): Observable<any> {
    let url = environment.BASE_URL + '/v1/auth/generate-reset-otp';
    return this.http.post(url, payload);
  }
  changePassword(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/auth/reset-password';
    return this.http.post(url, payload);
}
}
